import useFetch from '../hooks/useFetch';

const getVendedores = async () => {
  try {
    return await useFetch.fnPost('clientes/getVendedores', {});
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getAsociacionesUsuarioVendedor = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/getAsociacionesUsuarioVendedor', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const guardarUsuarioVendedor = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/guardarUsuarioVendedor', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const eliminarUsuarioVendedor = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/eliminarUsuarioVendedor', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getMiVendedor = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/getMiVendedor', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getClientesVendedor = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/getClientesVendedor', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const guardarGeolocalizacion = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/guardarGeolocalizacion', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const getHistorialGeolocalizacion = async (dataRequest) => {
  try {
    return await useFetch.fnPost('clientes/getHistorialGeolocalizacion', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
};

const ClientesService = {
  getVendedores,
  getAsociacionesUsuarioVendedor,
  guardarUsuarioVendedor,
  eliminarUsuarioVendedor,
  getMiVendedor,
  getClientesVendedor,
  guardarGeolocalizacion,
  getHistorialGeolocalizacion,
};

export default ClientesService;
